export function atomicService(http) {
    const serviceName = "Erms";

    return {
        getEmployee:(estekhdam,prsCostCenterSubCode)=>{
            const data={
                    estekhdam,
                    prsCostCenterSubCode
                }
            return http.post(serviceName+"/GetEmployee",data)
        },
        getStatuses:()=>{
            return http.get(serviceName+"/GetStatuses");
        },
        getHoldReasons:()=>{
            return http.get(serviceName+"/GetHoldReasons");
        },
        getProjects:(roleMembers)=>{
            const data=roleMembers;
            return http.post(serviceName+"/GetProjects",data);
        },
        getAllProjects:()=>{
            return http.get(serviceName+"/GetAllProjects");
        },
        getActivities:(projectId,roleMembers)=>{
            const data={
                projectId,
                roleMembers
            }
            return http.post(serviceName+"/GetActivities",data);
        },
        getDisciplines:()=>{
            return http.get(serviceName+"/GetDisciplines");
        }

    }
}